<template>
    <div class="contarin">
        <div class="con-left" ref="menuWrapper">
            <div>
                <div class="menuLeft">
                    <div class="conLi" ref="menuList" v-for="(item, index) in tabSidle"  :class="{'active': currentIndex === index, 'f26': item.name.length > 4}" :key="item.id" @click="selectMenu(index, $event)">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
        <div class="con-right" ref="foodsWrapper" @scroll="handleScroll($event)" @touchend='touchend'>
            <div>
                <ul v-for="item in tabSidle" :key='item.id' class="itemLi food-list-hook" ref="foodList">
                    <li class="itemOne borderBot" v-for="its in item.subCategoryList" :key="its.id">
                        <h1 class="title f28 col333" v-text="its.name"></h1>
                        <ul>
                            <li v-for="it in its.subCategoryList" :key="it.id">
                                <div class="goodsList" @click="onTab(it.id, it.name)">
                                    <div class="img">
                                        <img v-lazy="$viewImageNew(it.imgUrl, 400,400)" alt="">
                                    </div>
                                    <div class="h3">{{it.name}}</div>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    name: 'category',
    data () {
        return {
            menus: 2,
            title: '全部商品',
            tab: 1,
            titleRight: '',
            userInfo: '',
            merchantCode: '',
            tabSidle: [],
            scrollY: 0,
            listHeight: [],
            clickIndex: 0,
            isUpdate: true,
            setTime: null,
            clickTrue: false,
            scrollTimer: null,
            element: null
        }
    },
    computed: {
        currentIndex () {
            for (let i = 0; i < this.listHeight.length; i++) {
                let height1 = this.listHeight[i]
                let height2 = this.listHeight[i + 1]
                if (!height2 || (this.scrollY >= height1 && this.scrollY < height2)) {
                    if (this.clickIndex === 0) {
                        return this.clickIndex
                    }
                    return this.clickIndex || i
                }
            }
            return 0
        }
    },
    methods: {
        ...mapActions(['findCategoryListData']),
        selectMenu (index, e) {
            e.stopPropagation()
            if (this.clickIndex === index) {
                return false
            }
            this.clickIndex = index
            this.clickTrue = true
            this.element = document.getElementsByClassName('con-right')[0]
            clearInterval(this.scrollTimer)
            this.ScrollTop(this.listHeight[index], 200)
        },
        scrollHeight (height) {
            this.element = document.getElementsByClassName('con-right')[0]
            this.ScrollTop(height, 0)
        },
        ScrollTop (number = 0, time) {
            let el = this.element
            if (!time) {
                document.body.scrollTop = el.scrollTop = number
                return number
            }
            const spacingTime = 20 // 设置循环的间隔时间  值越小消耗性能越高
            let spacingInex = time / spacingTime // 计算循环的次数
            let nowTop = document.body.scrollTop + el.scrollTop // 获取当前滚动条位置
            let everTop = (number - nowTop) / spacingInex // 计算每次滑动的距离
            this.scrollTimer = setInterval(() => {
                if (spacingInex > 0) {
                    spacingInex--
                    this.ScrollTop(nowTop += everTop)
                } else {
                    clearInterval(this.scrollTimer) // 清除计时器
                }
            }, spacingTime)
        },
        onTab (id, name) {
            this.$emit('scrollTop', this.scrollY)
            localStorage.setItem('goodsListBack', this.$router.history.current.fullPath)
            localStorage.removeItem('tabNav')
            localStorage.removeItem('activityData')
            this.$router.push({ path: '/b2b/goods/goodsList', query: { id: id, name: name, screenType: 2 } })
        },
        handleScroll (e) {
            if (this.clickTrue) {
                return false
            }
            this.clickIndex = null
            if (e.target.scrollTop >= 0) {
                this.scrollY = Math.abs(Math.round(e.target.scrollTop))
                let h = this.$refs.menuList[this.currentIndex].offsetTop + this.$refs.menuList[this.currentIndex].clientHeight * 3 - this.$refs.menuWrapper.clientHeight
                if (h > 0) {
                    this._followScroll(h)
                } else {
                    if (this.listHeight[5] >= this.scrollY) {
                        this._followScroll()
                    }
                }
            }
        },
        _followScroll (h = 0) {
            this.element = document.getElementsByClassName('con-left')[0]
            if (this.scrollTimer) {
                clearInterval(this.scrollTimer)
            }
            this.ScrollTop(h, 200)
        },
        touchend () {
            this.clickTrue = false
        },
        _calculateHeight () {
            let foodList = this.$refs.foodList
            let height = 0
            this.listHeight.push(height)
            for (let i = 0; i < foodList.length; i++) {
                let item = foodList[i]
                height += item.offsetHeight
                this.listHeight.push(height)
            }
            this.$nextTick(() => {
                this.scrollHeight(0)
            })
        },
        async getcategroyList () {
            this.findCategoryListData({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            }).then((data) => {
                this.tabSidle = data
                this.$nextTick(() => {
                    this._calculateHeight()
                })
            })
        }
    },
    activated () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (this.$route.meta.isUseCaChe) {
            this.clickIndex = 0
            this.getcategroyList()
        }
    },
    async mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        await this.getcategroyList()
    }
}
</script>
<style lang="scss" scoped>
    .contarin{
        height: 100%;
        display: flex;
        justify-content: flex-start;
        overflow: hidden;
        position: relative;
        .conLi{
            position: relative;
            text-align: center;
            height: 88px;
            line-height: 88px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
        .con-left{
            flex: 0 0 208px;
            height: calc(100% - 50px);
            background: #f5f5f5;
            color: #333333;
            overflow-y: auto;
            &::-webkit-scrollbar {
                display: none;
            }
            .menuLeft{
                background: #f5f5f5;
            }
            .active{
                background: #ffffff;
                color: #FF7A45;
                position: relative;
                font-size: 30px !important;
                &::before{
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 20px;
                    background: url(../../../../assets/img/b2b/left_icon.png) no-repeat;
                    background-size: 100% 100%;
                    width: 6px;
                    height: 40px;
                }
            }
        }
        .con-right{
            width: 100%;
            overflow: auto;
            padding-bottom: 200px;
            &::-webkit-scrollbar {
                display: none;
            }
            ul.itemLi{
                position: relative;
                padding-bottom: 20px;
                li{
                    overflow: hidden;
                    position: relative;
                    background: #ffffff;
                    .title{
                        padding-top: 32px;
                        padding-bottom: 24px;
                    }
                    &.itemOne{
                        padding-left: 28px;
                    }
                    &:last-child {
                        &::before{
                            border: none
                        }
                    }
                    ul{
                        display: flex;
                        flex-wrap: wrap;
                        &:not(:last-child) {
                            border-bottom: 2px solid #D1D1D6;
                        }
                        li{
                            width: 33.33%;
                            display: flex;
                            justify-content: flex-start;
                            padding-bottom: 48px;
                            .goodsList{
                                width: 128px;
                                // height: 128px;
                                text-align: center;
                                .img{
                                    width: 128px;
                                    height: 128px;
                                    display: flex;
                                }
                                .h3{
                                    font-size: 22px;
                                    color: #999999;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 1;
                                    overflow: hidden;
                                    white-space: normal;
                                    word-break: break-all;
                                    transform: scale(0.95);
                                    width: 100%;
                                }
                                img{
                                    display: block;
                                    align-self: center;
                                    justify-self: center;
                                    margin: 0 auto;
                                    background: #f2f3f5;
                                    object-fit: cover;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>